import { render, staticRenderFns } from "./InvestorLifeStage.vue?vue&type=template&id=09d82a54"
import script from "./InvestorLifeStage.vue?vue&type=script&lang=js"
export * from "./InvestorLifeStage.vue?vue&type=script&lang=js"
import style0 from "./InvestorLifeStage.vue?vue&type=style&index=0&id=09d82a54&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports